import React from 'react';
import { formatDistanceToNow } from 'date-fns';
import { cn } from '../../lib/utils';
import SafeIcon from '../common/SafeIcon';
import { FiClock, FiMessageSquare } from 'react-icons/fi';

const priorityColors = {
  urgent: 'text-priority-red border-priority-red bg-priority-red/10',
  high: 'text-orange-400 border-orange-400 bg-orange-400/10',
  normal: 'text-cyan-neon border-cyan-neon bg-cyan-neon/10',
  low: 'text-slate-400 border-slate-600 bg-slate-800',
};

export default function TicketList({ tickets, activeTicketId, onSelectTicket }) {
  return (
    <div className="w-full md:w-80 lg:w-96 border-r border-navy-700 bg-navy-800/50 flex flex-col h-[calc(100vh-4rem)]">
      <div className="p-4 border-b border-navy-700 bg-navy-800">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-white">Active Queue</h2>
          <span className="text-xs font-mono bg-navy-700 px-2 py-1 rounded text-cyan-neon">
            {tickets.length} OPEN
          </span>
        </div>
        <div className="relative">
          <input 
            type="text" 
            placeholder="Search ID, customer, or keyword..." 
            className="w-full bg-navy-900 border border-navy-600 rounded-lg py-2 pl-3 pr-10 text-sm text-slate-200 placeholder-slate-500 focus:outline-none focus:border-cyan-neon focus:ring-1 focus:ring-cyan-neon transition-all"
          />
        </div>
      </div>

      <div className="flex-1 overflow-y-auto scrollbar-hide p-2 space-y-2">
        {tickets.map(ticket => (
          <div
            key={ticket.id}
            onClick={() => onSelectTicket(ticket.id)}
            className={cn(
              "p-4 rounded-xl cursor-pointer transition-all duration-200 border",
              activeTicketId === ticket.id 
                ? "bg-navy-700 border-cyan-neon/50 shadow-[0_0_15px_rgba(0,240,255,0.1)]" 
                : "bg-navy-800 border-transparent hover:border-navy-600 hover:bg-navy-700/50"
            )}
          >
            <div className="flex justify-between items-start mb-2">
              <span className="text-xs font-mono text-slate-400">{ticket.id}</span>
              <span className={cn("text-[10px] uppercase font-bold px-2 py-0.5 rounded border", priorityColors[ticket.priority])}>
                {ticket.priority}
              </span>
            </div>
            <h3 className="text-sm font-medium text-white mb-2 line-clamp-2 leading-tight">
              {ticket.subject}
            </h3>
            <div className="flex items-center justify-between mt-3 text-xs text-slate-500">
              <div className="flex items-center gap-2">
                <img src={ticket.customer.avatar} alt="avatar" className="w-5 h-5 rounded-full" />
                <span className="truncate max-w-[100px]">{ticket.customer.name}</span>
              </div>
              <div className="flex items-center gap-1">
                <SafeIcon icon={FiClock} />
                <span>{formatDistanceToNow(new Date(ticket.createdAt), { addSuffix: true })}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}